import { LandingPage } from "components/commons/LandingPage";
import React from "react";
interface Props {
  children: React.ReactNode;
}

export const MainLayoutSimple: React.FC<Props> = ({ children }) => {
  const isInStandaloneMode = window.matchMedia(
    "(display-mode: standalone)"
  ).matches;

  return (
    <>
      {isInStandaloneMode ? (
        <div className="main-layout--wrapper min-h-screen min-w-screen bg-base-300">
          <div
            className={`flex flex-col justify-start w-full min-h-screen h-full text-base-content overflow-hidden`}
          >
            {children}
          </div>
        </div>
      ) : (
        <LandingPage />
      )}
    </>
  );
};
